import React, { memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent = ({
  selectedDate,
  onChange,
  dateFormat = "dd/MM/yyyy",
  placeholderText = "Select a date",
  isClearable = true,
  minDate = null,
  maxDate = null,
  disabled = false,
  ...props
}) => {
  return (
    <>
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
        isClearable={isClearable}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        className="form-control"
        onKeyDown={(e) => e.preventDefault()}
        {...props}
      />
    </>
  );
};

export default memo(DatePickerComponent);
